module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/group-chat-6d69d85d2d22729a8493f08413a06f17.svg";